import { captureEvent } from "@Light/app/analytics";

export type DocumentLinkProps = {
  document: string;
  href: string;
  children: React.ReactNode;
};

export const DocumentLink = ({
  document,
  href,
  children,
}: DocumentLinkProps) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => {
      captureEvent("document_link_clicked", { document });
    }}
  >
    {children}
  </a>
);
